import { render, staticRenderFns } from "./item1.vue?vue&type=template&id=6cc6286c&scoped=true"
import script from "./item1.vue?vue&type=script&lang=js"
export * from "./item1.vue?vue&type=script&lang=js"
import style0 from "./item1.vue?vue&type=style&index=0&id=6cc6286c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc6286c",
  null
  
)

export default component.exports